import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

// components
import LoadingScreen from "../components/loading-screen";
//
import Login from "../pages/LoginPage";
import { getCategories } from "../redux/slices/category";
import { getCountries } from "../redux/slices/country";
import { getPositions } from "../redux/slices/positions";
import { getSeasons } from "../redux/slices/season";
import { getStadiums } from "../redux/slices/stadium";
import { useDispatch } from "../redux/store";
import { useAuthContext } from "./useAuthContext";

// ----------------------------------------------------------------------
AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const dispatch = useDispatch();

  // TODO: fetch ...............

  useEffect(() => {
    dispatch(getCategories());
    dispatch(getCountries());
    dispatch(getPositions());
    dispatch(getStadiums({}));
    dispatch(getSeasons({}));
  }, [dispatch]);

  const { isAuthenticated, isInitialized } = useAuthContext();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    // TODO: change this to !isAuthenticated
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <> {children} </>;
}
